<template>
    <div>
        <div class="item-block" >
            <div class="item-tops" >
                <span class="pice-name">{{ goodsSkuDetail.sku_name }}</span>
                <span class="pice-name-size" v-if="goodsSkuDetail.attr&&goodsSkuDetail.attr.goods_size">({{ goodsSkuDetail.attr.goods_size }})</span>
            </div>
            <div style="color:var(--detail-sub-color);margin-bottom: 10px;font-size: var(--detail-font-size);">
                <span>已售</span>
                <span>{{ goodsSkuDetail.sale_num }}{{ goodsSkuDetail.unit }}</span>
            </div>
            <div class="goods-label-wrap">
                <goodsLevel :goods="goodsSkuDetail"></goodsLevel>
                <goodsLabel :goods="goodsSkuDetail" width="400"></goodsLabel>
                <goodsGroupLabel :goods="goodsSkuDetail"></goodsGroupLabel>
            </div>
            <div class="discount-banner "
             :style="{backgroundColor:comactiveinfo.bag}"
             v-if="activeinfo.promotion_label"
                >
                <div class="activity-name">
                    <!-- <i class="discount-icon iconfont iconicon_naozhong"></i>         -->
                     <img  style="margin-left:16px;" :src="comactiveinfo.iocn" alt="">
                    <span style="font-size: 20px;" >{{comactiveinfo.titlename}}</span>
                </div>
                <div class="surplus-time" v-if="goodsSkuDetail.promotion_type == 1 && discountTimeMachine.currentTime && addonIsExit.discount">
                    <span>{{ discountText }}</span>
                    <count-down class="count-down" v-on:start_callback="countDownS_cb()"
                        v-on:end_callback="countDownE_cb()" :currentTime="discountTimeMachine.currentTime"
                        :startTime="discountTimeMachine.startTime" :endTime="discountTimeMachine.endTime" :dayTxt="'天'"
                        :hourTxt="'小时'" :minutesTxt="'分钟'" :secondsTxt="'秒'"></count-down>

                    <!-- :tipText="'距离开始文字1'"
                    :tipTextEnd="'距离结束文字1'"
                    :endText="'结束自定义文字2'"-->
                </div>
                
            </div>
            <div class="promotion-price" :class="{ 'promotion-price--plain': !activeinfo.promotion_label }">
         
                <template v-if="activeinfo.promotion_label">
                    <!-- 活动类型价格显示 -->
                    <showPirceInfo :comactiveinfo="comactiveinfo" :token="token" :goodsSkuDetail="goodsSkuDetail">
                    </showPirceInfo>
                </template>
                <template v-else>
                    <!-- 非营销活动类型价格显示 -->
                    <notActivityPirce :goodsSkuDetail="goodsSkuDetail" :token="token"></notActivityPirce>
                </template>
            <dl class="mdoleDome-goods_attr_format" v-if="goodsSkuDetail.goods_limit > 0">
                <dt class="ns-text-color-gray active-hd">限购规则</dt>
                <dd>提示：本商品为限购商品，超过{{ goodsSkuDetail.goods_limit }}{{ goodsSkuDetail.unit }}恢复原价</dd>
            </dl>
            <dl v-if="activeinfo.promotion_info?.price_json&&activeinfo.promotion_info.price_json.length>0">
                    <dt class="active-hd">
                        阶梯规则
                    </dt>
                    <dd>
                        <span v-for="(item,index) in activeinfo.promotion_info.price_json" :key="index">
                        
                            {{item.num}} {{goodsSkuDetail.unit}}起批     
                             <span  style=" color: red;">
                                        <em >¥</em>
                                       <template v-if="token">
                                        {{goodsSkuDetail.sale_control?.view_price? item.price :goodsSkuDetail.sale_control.not_buy_msg}}
                                       </template>
                                       <template v-else>
                                         登录可见
                                       </template>
                           </span >;
                      </span>
                    </dd>
             </dl>
            <dl  v-if="goodsSkuDetail.get_free_goods !== null && goodsSkuDetail.get_free_goods !== undefined && goodsSkuDetail.get_free_goods !== ''">
                <dt class="active-hd">换购规则</dt>
                <dd v-if="goodsSkuDetail.get_free_goods !== null">
                    <div class="getFreeBox">
                        <p>{{ goodsSkuDetail.get_free_goods.goods_range>0?('(可任选'+goodsSkuDetail.get_free_goods.goods_range+'种)'):'(可任选个数，无限制)' }}</p>
                        <div>
                            <template v-for="freeItem in returnFreeInfo">
                                <p v-if="freeItem.title!=''">{{ freeItem.title }}</p>
                                <p>{{ freeItem.text }}</p>
                            </template>
                        </div>
                    </div>
                </dd>
                <dd v-if="goodsSkuDetail.get_free_goods === null || goodsSkuDetail.get_free_goods === undefined || goodsSkuDetail.get_free_goods === ''">无换购商品</dd>
            </dl>
            </div>
            <div class="goods-qualification-wrap">
                <el-button type="primary" size="mini" @click="openGoodsInfo(goodsSkuDetail.goods_id)">药品资质</el-button>
            </div>
        </div>
        <el-dialog title="药品资质" v-loading="goods_info_loading" :visible.sync="goods_info_state" width="30%" center top="300px">
            <div class="goods_info_filter" v-if="goods_info_arr.length>0">
                <el-radio-group v-model="filterType" size="small">
                    <el-radio-button label="all">全部</el-radio-button>
                    <el-radio-button label="product">产品资料</el-radio-button>
                    <el-radio-button label="inspection">检验报告</el-radio-button>
                </el-radio-group>
            </div>
            <div class="goods_info_box" v-if="goods_info_arr.length>0">
                <template v-for="item in filteredGoodsInfo">
                    <div class="goods_info_item">
                        <div>
                            <span class="el-icon-document"></span>
                            <span>{{ item.name }}</span>
                        </div>
                        <div @click="seeGoodsInfo(item)">
                            <span>查看</span>
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </template>
                <div v-if="filteredGoodsInfo.length === 0" class="no-data">暂无相关资质文件</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import showPirceInfo from "./compontens/showPirceInfo"
import notActivityPirce from './compontens/notActivityPirce.vue';
import CountDown from "vue2-countdown";
import goodsCodeLabel from "@/components/goods-label/goods-code-label.vue";
import goodsGroupLabel from "@/components/goods-label/goods-group-label.vue";
import goodsLabel from "@/components/goods-label/goods-label.vue";
import goodsLevel from "@/components/goods-label/goods-level.vue";
import { getGoodsInfoById } from '@/api/order/order';
export default {
    components: {
        showPirceInfo,
        notActivityPirce,
		CountDown,
		goodsCodeLabel,
		goodsGroupLabel,
		goodsLabel,
		goodsLevel
	},
    props: {
        goodsSkuDetail: {
            type: Object,
            default: () => { },
        },
        token: {
            type: String,
            default: ''
        },
        goods_member_price: {
            type: Object,
            default: () => { }
        },
        activeinfo: {
            type: Object,
            default: () => { }
        },
        discountTimeMachine:{
            type:Object,
            default:()=>{}
        },
        addonIsExit:{
            type:Object,
            default:()=>{}
        },
        discountText:{
            type:String,
            default:''
        }

    },
    data() {
        return {
            goods_info_state: false,
            goods_info_loading: false,
            goods_info_arr: [],
            filterType: 'all',
        };
    },
    /**
     *   seckill   秒杀
     *   discount  特价
     *   wholesale 阶梯
     */
    computed: {
        filteredGoodsInfo() {
            if (this.filterType === 'all') {
                return this.goods_info_arr;
            }
            return this.goods_info_arr.filter(item => item.type === this.filterType);
        },
        // 活动信息数据进行处理
        comactiveinfo() {
            let updatedInfo = {};
            let coupon_price = this.goodsSkuDetail.coupon_price;
            let sub_coupon_price = (coupon_price!=undefined&&coupon_price!=''&&coupon_price!=null&&parseFloat(coupon_price)>0?coupon_price:'');
            switch (this.activeinfo.promotion_label) {
                case 'seckill':
                    
                    updatedInfo = {
                        name: "秒杀价",
                        price: (parseFloat(this.activeinfo.promotion_info.price)>parseFloat(this.activeinfo.promotion_info.seckill_price)?this.activeinfo.promotion_info.price:''),
                        activity_price: this.activeinfo.promotion_info.seckill_price,
                        coupon_price:sub_coupon_price,
                        iocn:require('../../../assets/images/miao.png'),
                        titlename:'秒杀专区',
                        bag:'#32BC6F'
                    }
                    break;
                case 'discount':
                    updatedInfo = {
                        name: "特价",
                        price: (parseFloat(this.activeinfo.promotion_info.price)>parseFloat(this.activeinfo.promotion_info.discount_price)?this.activeinfo.promotion_info.price:''),
                        activity_price: this.activeinfo.promotion_info.discount_price,
                        coupon_price:sub_coupon_price,
                        iocn:require('../../../assets/images/te.png'),
                         titlename:'限时特价',
                         bag:'#44B2FC'
                    }
                    break;
                case 'wholesale':
                    updatedInfo = {
                        name: "阶梯价",
                        price: this.goodsSkuDetail.price,
                        activity_price: this.activeinfo.promotion_info.min_price,
                        coupon_price:sub_coupon_price,
                        max_pice:this.activeinfo.promotion_info.max_price,
                        price_json: this.activeinfo.promotion_info.price_json,
                        iocn:require('../../../assets/images/pi.png'),
                         titlename:'阶梯专区',
                          bag:'#F88B57'
                    }
                    break;
            }
            return updatedInfo
        },
        returnFreeInfo() {
            let textArr = [];
            let text_bool = (!this.goodsSkuDetail||!this.goodsSkuDetail.get_free_goods||!this.goodsSkuDetail.get_free_goods.getFreeGoods);
            if(text_bool){
                return textArr;
            }
            let bool = (this.goodsSkuDetail.get_free_goods.is_ladder > 0);
            // 当前主商品的单位
            let main_unit = (this.goodsSkuDetail.unit ? this.goodsSkuDetail.unit : '盒');
            this.goodsSkuDetail.get_free_goods.getFreeGoods.forEach(item => {
                // 是否是本商品
                let ifBenPing = (item.goods_id===this.goodsSkuDetail.goods_id);
                // 副商品单位
                let fu_unit = (item.goods.unit?item.goods.unit:'盒');
                if (bool) {
                    if (typeof item.ladder_json === 'string') {
                        item.ladder_json = JSON.parse(item.ladder_json)
                    }
                    item.ladder_json.forEach((item1, index) => {
                        let limit = (item.limit||item.goods_limit||0);
                        let price = (parseFloat(item1.rangPrice)*parseInt(item1.rang)).toFixed(2);
                        let str = `单次购买本商品${item1.mainRang}${main_unit}+${price}元换购${item1.rang}${fu_unit}${ifBenPing?'本品':item.goods.goods_name}`;
                        if(limit>0){
                            str += `,限购${item.limit}${fu_unit}`;
                        }
                        let textObj = {title:'',text:str};
                        if(ifBenPing){
                            textArr.unshift(textObj);
                        }else{
                            textArr.push(textObj);
                        }
                    });
                } else {
                    let price = (parseFloat(item.price)*parseInt(item.num)).toFixed(2);
                    let str = `单次购买本商品${item.count}${main_unit}+${price}元换购${item.num}${fu_unit}${ifBenPing?'本品':item.goods.goods_name}`;
                    if (item.limit > 0) {
                        str +=`,限购${item.limit}${fu_unit}`;
                    }
                    let textObj = {title:'',text:str}
                    textArr.push(textObj);
                }
            })
            return textArr;
        },
    },
    methods:{
        openGoodsInfo(id) {
            this.goods_info_state = true;
            this.goods_info_loading = true;
            this.filterType = 'all';
            getGoodsInfoById({
                goods_id: id
            }).then(res => {
                this.goods_info_arr = [];
                if (res.inspection_data != null) {
                    const inspectionList = res.inspection_data.map(item => ({
                        ...item,
                        type: 'inspection'
                    }));
                    this.goods_info_arr = this.goods_info_arr.concat(inspectionList);
                }
                if (res.product_data != null) {
                    const productList = res.product_data.map(item => ({
                        ...item,
                        type: 'product'
                    }));
                    this.goods_info_arr = this.goods_info_arr.concat(productList);
                }
                this.goods_info_loading = false;
            })
        },
        seeGoodsInfo(info) {
            window.open(info.path, '_blank', 'width=800,height=600,top=100,left=100,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes');
        },
        countDownE_cb(){
            this.$emit('countDownE_cb')
        },
        countDownS_cb(){
            this.$emit('countDownS_cb')
        }
    }
}
</script>

<style lang="scss" scoped>
.promotion-price{
    padding: 20px 0 10px 0;
    background: #F3F3F3;
}

.promotion-price--plain{
    padding: 0;
    background: transparent;
}

.active-hd{
    display: inline-block;
    min-width: 88px;
    height: 35px;
    line-height: 35px;
    text-align-last : justify !important;
    padding-left: 16px;
    font-size: 14px;
    margin-right: 16px;
    color: #2c2626e0;
    font-weight: 600;
   
}
dd{
    padding-left: 16px;
}
.getFreeBox{
    display: flex;
    flex-direction: column;
    gap: 6px;
    p{
        color: #32BC6F;
        line-height: 1rem;
    }
    >div{
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
}
.goods-label-wrap{
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 10px;
}
.item-tops{
    display: flex;
    align-items: baseline;
    gap: 6px;
    .pice-name-size{
        color: #32BC6F;
        font-weight: bold;
        font-size: 16px;
    }
}
.goods-qualification-wrap{
    padding: 12px 0 0 0;
}
.goods_info_filter{
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
}
.goods_info_box{
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 300px;
    overflow-y: auto;
    .goods_info_item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f5f5f5;
        border-radius: 6px;
        padding: 12px;
        box-sizing: border-box;
        >div{
            display: flex;
            align-items: center;
            gap: 6px;
            >span{
                font-size: 16px;
            }
        }
        >div:nth-child(2){
            width: 55px;
            flex-shrink: 0;
            margin-left: 12px;
            cursor: pointer;
        }
    }
    .no-data{
        text-align: center;
        padding: 40px 0;
        color: #999;
        font-size: 14px;
    }
}
</style>
